module.exports = __webpack_public_path__ + "assets/30b03e17fd55c8d5d9f1024a7280e819.mp3";